import React from "react";
import Image from '../../images/self.jpg';
import './image.css';
export default function Self()
{
    return(
        
        <img src={Image} className="image" alt=""></img>
    );
}
